import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IInquiryCndsState, IProjectListState, IUsr0302P3State } from '../../models/usr/usr0302p3_model';

const initialState: IUsr0302P3State = {
    // 조회조건
    inquiryCnds: {
        instCd: '',   // 기관코드
        pjNm:   '',   // 프로젝트명
        cusNm:  '',   // 고객사
    },

    // 프로젝트
    projectList: [],

    pageSize: 5,   // 페이징사이즈
    current:  1,   // 현재페이지

}

export const usr0302p3_Slice = createSlice({
    name: "usr0302p3_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState});
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setProjectList: (state, action:PayloadAction<IProjectListState[]>) => {
            state.projectList = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default usr0302p3_Slice.reducer;
export const Usr0302p3Action  = usr0302p3_Slice.actions;
export const Usr0302p3Reducer = usr0302p3_Slice.reducer;